<template>
  <fin-dialog v-if="dialog"
              v-model="dialog"
              :actionBtnBottom="$vuetify.breakpoint.xs"
              :fullscreen="$vuetify.breakpoint.xs"
              :max-width="dialogWidth"
              content-class="fin-subscription-dialog"
              style="overflow: hidden;"
              @input="(val) => {if (val === false){cancel()}}">

    <fin-subscription-content :feature-id="featureId"
                              :restriction-options="restrictionOptions"
                              :restriction-type="restrictionType"
                              @changeSubscriptionClicked="cancel"
                              @showSubscriptionsClicked="cancel"/>
  </fin-dialog>
</template>

<script>
import {mapGetters} from "vuex"
import {EventBus} from "@/plugins/fincraft"
import FinSubscriptionContent from "@/components/common/subscription/content"

export default {
  name: "FinSubscriptionPopup",
  components: {FinSubscriptionContent},
  data() {
    return {
      dialog: false,
      featureId: undefined,
      restrictionType: undefined,
      restrictionOptions: undefined,
      selectedFilter: false,
    }
  },
  computed: {
    ...mapGetters('auth', ['groupPriceModel']),
    dialogWidth() {
      return this.groupPriceModel?.nextPriceModel ? 1000 : 800
    }
  },
  methods: {
    cancel() {
      this.dialog = false
    },
    showPopup(featureId, restrictionType, restrictionOptions) {
      this.featureId = featureId
      this.restrictionType = restrictionType
      this.restrictionOptions = restrictionOptions
      this.dialog = true
    },
  },
  mounted() {
    EventBus.$on('showSubscriptionPopup', this.showPopup)
  },
  beforeDestroy() {
    EventBus.$off('showSubscriptionPopup', this.cancel)
  }
}
</script>

<style lang="scss" scoped>

</style>
